import { MainContainer } from './Container.styled';

export const Container = ({ children }) => {
  return <MainContainer>{children}</MainContainer>;
};

export default Container;
